import { IonContent, IonPage, useIonModal } from '@ionic/react'
import classNames from 'classnames'

import {
  MODAL_WRAPPER_X_PADDING,
  ModalCloseButton,
  ModalContainer,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { ControlHistoryView } from '@apps-common/components/modals/unit-history/ControlHistoryView'
import { ProgramHistoryView } from '@apps-common/components/modals/unit-history/ProgramHistoryView'
import { ScheduleHistoryView } from '@apps-common/components/modals/unit-history/ScheduleHistoryView'
import { TriggerHistoryView } from '@apps-common/components/modals/unit-history/TriggerHistoryView'
import { ModalDismiss } from '@apps-common/config/modal'
import { useModalNoBlur } from '@apps-common/hooks/useModalNoBlur'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

export interface IHistoryOptionsModal {
  type: 'control' | 'schedule' | 'trigger' | 'program'
  name: string
  id: number
  unitId?: string
  requiresState?: boolean
}

export const HistoryModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IHistoryOptionsModal
}) => {
  const { type, name, id, unitId, requiresState } = componentProps

  return (
    <ModalContainer
      containerClasses=''
      innerClasses='!shadow-md md:!max-w-[360px] !min-h-[calc(95dvh-30px)] !h-[calc(98dvh-30px)] md:!ml-auto md:!mr-[15px]'
      onDismiss={onDismiss}
    >
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <div className='w-[85%]'>
            <ModalHeader subtitle={`${type} history`} title={name} subtitleClasses='capitalize' />
          </div>
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <IonPage>
        <IonContent
          style={{
            '--background': 'transparent'
          }}
        >
          <div className={classNames(MODAL_WRAPPER_X_PADDING, 'pt-[90px] pb-[30px]')}>
            {type === 'control' && <ControlHistoryView controlId={id} unitId={unitId} requiresControlState={requiresState} />}
            {type === 'schedule' && <ScheduleHistoryView scheduledId={id} unitId={unitId} />}
            {type === 'trigger' && <TriggerHistoryView triggerId={id} unitId={unitId} />}
            {type === 'program' && <ProgramHistoryView unitId={unitId} />}
          </div>
        </IonContent>
      </IonPage>
    </ModalContainer>
  )
}

export const useHistoryModal = (props: IHistoryOptionsModal) => {
  const modalBlur = useModalNoBlur()

  const [present, dismiss] = useIonModal(HistoryModal, {
    componentProps: props,
    onDismiss: (data: string, role: string) => dismiss(data, role)
  })

  const open = () => {
    present({
      ...modalBlur,
      enterAnimation: modalSlideUpEnterAnimation,
      leaveAnimation: modalSlideUpLeaveAnimation
    })
  }

  return { open }
}
